'use client'

import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import LearnMoreTiles from '@/components/LearnMoreTiles'

const FortoResults: FC<{}> = () => {
    const { xsScreen, smScreen, mdScreen } = useDevice()

    const { spacing } = LuneTheme
    return (
        <Box>
            <Stack
                sx={{
                    mb: {
                        xs: `${spacing(7)} !important`,
                        sm: `${spacing(7)} !important`,
                        md: `${spacing(9)} !important`,
                        lg: `${spacing(9)} !important`,
                        xl: `${spacing(9)} !important`,
                    },
                }}
                spacing={5}
            >
                <Text
                    variant={mdScreen ? 'h5' : 'h4'}
                    sx={{
                        textAlign: smScreen ? 'left' : 'center',
                    }}
                >
                    Results
                </Text>
                <Text
                    variant={mdScreen ? 'body2' : 'body1'}
                    sx={{
                        textAlign: smScreen ? 'left' : 'center',
                    }}
                >
                    {`By integrating Lune’s emissions intelligence, Forto has strengthened its reputation as a sustainability leader in European logistics.`}
                </Text>
            </Stack>
            <LearnMoreTiles
                sx={{
                    ...(xsScreen
                        ? {}
                        : {
                              gap: 9,
                          }),
                }}
                renderOnSx={{
                    ...(xsScreen
                        ? {}
                        : {
                              flex: '0 0 calc(33% - 72px)',
                          }),
                }}
                tiles={[
                    {
                        title: <>Acquiring new prospects </>,
                        icon: '/icons/icon-lead-innovation.png',
                        description:
                            'Becoming green leaders has opened many new doors. Forto speaks as a thought leader at major events like Logistics Summit, and prospects now proactively approach Forto for quotations, recognising them as a green frontrunner',
                    },
                    {
                        title: <>Growing deal value</>,
                        icon: '/icons/icon-easy-platform.png',
                        description: `Over 60% of customers have adopted Forto’s climate action solutions, which are underpinned by accurate emissions reporting and reduction initiatives`,
                    },
                    {
                        title: <>Deepening customer loyalty</>,
                        icon: '/icons/icon-high-quality-peace-1.png',
                        description:
                            'The sustainability team has seen its work resonate across the business. Customers appreciate that the data is easy to understand and that consistency builds trust year after year',
                    },
                ]}
            />
        </Box>
    )
}

export default FortoResults
